import { CopyIcon } from "@phosphor-icons/react/dist/csr/Copy";
import { InfoIcon } from "@phosphor-icons/react/dist/csr/Info";
import { Button } from "@volca/ui/components/ui/button";
import {
  Popover,
  PopoverTrigger,
  PopoverContent,
  PopoverTitle,
} from "@volca/ui/components/ui/popover";
import { Stack } from "@volca/ui/components/ui/stack";
import { Text } from "@volca/ui/components/ui/text";
import {
  Tooltip,
  TooltipContent,
  TooltipTrigger,
} from "@volca/ui/components/ui/tooltip";
import { useDevPopoverOffset } from "./use-dev-popover-offset";
import { useDevSession } from "./use-dev-session";

export const DevSessionPopover = () => {
  const { session, copyContext } = useDevSession();
  const sideOffset = useDevPopoverOffset();
  const rows = [
    ["Environment", session.environment],
    ["API", session.api],
    ["Route", session.route],
    ["Signed in", session.signedInAs ?? "Signed out"],
    ["Acting as", session.actingAs ?? "Your own account"],
    ["Role", session.role ?? "None"],
    ["Business", session.business ?? "None"],
    ["Business ID", session.businessId ?? "None"],
    ["Overrides", JSON.stringify(session.overrides)],
  ];
  return (
    <>
      <Popover>
        <PopoverTrigger
          render={
            <Button
              variant="ghost"
              size="xs"
              className="max-md:size-11"
              aria-label="Session"
            />
          }
        >
          <InfoIcon aria-hidden />
          <span className="max-md:hidden">Session</span>
        </PopoverTrigger>
        <PopoverContent
          side="top"
          align="end"
          sideOffset={sideOffset}
          className="max-h-[min(32rem,70svh,var(--available-height))] w-[min(26rem,calc(100vw-1rem))] overflow-y-auto"
        >
          <PopoverTitle>Session</PopoverTitle>
          <Stack render={<dl />} gap={2}>
            {rows.map(([label, value]) => (
              <Stack direction="row" align="baseline" gap={3} key={label}>
                <Text
                  render={<dt />}
                  variant="caption"
                  tone="muted"
                  className="w-20 shrink-0"
                >
                  {label}
                </Text>
                <Text
                  render={<dd />}
                  variant="caption"
                  className="min-w-0 break-all"
                >
                  {value}
                </Text>
              </Stack>
            ))}
          </Stack>
          <Button
            size="sm"
            variant="outline"
            onClick={() => void copyContext()}
          >
            Copy context
          </Button>
        </PopoverContent>
      </Popover>
      <Tooltip>
        <TooltipTrigger
          render={
            <Button
              variant="ghost"
              size="icon-xs"
              className="size-8 max-md:size-11"
              aria-label="Copy session context"
              onClick={() => void copyContext()}
            />
          }
        >
          <CopyIcon aria-hidden />
        </TooltipTrigger>
        <TooltipContent sideOffset={8}>Copy session context</TooltipContent>
      </Tooltip>
    </>
  );
};
